let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if (api_token) window.API_ACCESS = api_token;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".js-quantity-button-minus");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".js-quantity-button-plus");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(mainFunction, delay) {
  let t = null;

  return (...args) => {
    if (t === null) {
      mainFunction(...args);
      t = setTimeout(() => {
        t = null;
      }, delay);
    }
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector('[id^="ModalClose-"]')) {
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, false)
      );
    }

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }

    this.modalInline = this.dataset.modalInline !== undefined;
  }

  connectedCallback() {
    if (this.modalInline || this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");

    if (!this.modalInline) {
      document.body.classList.add("overflow-hidden");
    }

    this.setAttribute("open", "");
    if (popup) popup.loadContent();

    if (!this.modalInline) {
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    window.pauseAllMedia();
  }

  hide() {
    if (!this.modalInline) {
      document.body.classList.remove("overflow-hidden");
    }

    document.body.dispatchEvent(new CustomEvent("modalClosed"));

    this.removeAttribute("open");

    if (!this.modalInline) {
      removeTrapFocus(this.openedBy);
    }

    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this
      .querySelectorAll(
        '.product-form__input input[type="radio"], .product-form__input select'
      )
      .forEach((option) =>
        option.addEventListener("change", this.whichInputUpdated.bind(this))
      );

    this.addEventListener("change", this.onVariantChange);
  }

  whichInputUpdated(element) {
    var optionname = element.target
      .closest(".product-form__input")
      .querySelector(".form__label").dataset.optionname;

    this
      .querySelectorAll(`.product-form__input`)
      .forEach((option) => option.classList.remove("activeset"));

    this
      .querySelectorAll(`.form__label[data-optionname="${optionname}"]`)
      .forEach((option) =>
        option.closest(".product-form__input").classList.add("activeset")
      );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, "", true);
      this.updateMedia();
      if (window.location.pathname.includes("/products/")) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    var allSelectors = document.querySelectorAll(
      ".section-main-product .product__variant-selector.option-select"
    );

    allSelectors.forEach((selector) => {
      if (selector != this) {
        this.updatePairUI(selector, this);
        selector.updateOptions();
      }
    });
  }

  updateOptions() {
    const selects = Array.from(this.querySelectorAll("select"));
    const selectValues = selects.map((select) => select.value);
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const radioValues = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(
        fieldset.querySelectorAll("input[type='radio']")
      ).find((radio) => radio.checked);

      checkedRadio
        .closest(".product-form__input")
        .querySelector(".selected-option").innerHTML = checkedRadio.value;

      return checkedRadio ? checkedRadio.value : null;
    });

    selects.forEach((select) => {
      const selectedOption = select
        .closest(".product-form__input")
        .querySelector(".selected-option");
      if (selectedOption) selectedOption.innerHTML = select.value;
    });

    this.options = [...selectValues, ...radioValues];
    this.options.sort();
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (variant.options.length !== this.options.length) {
        return false;
      }
      const sortedVariantOptions = [...variant.options].sort();
      return this.options.every((option, index) => {
        return option === sortedVariantOptions[index];
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    let card = this.closest("product-card");

    if (card) {
      const cardProductMedia = {
        url: this.currentVariant.featured_media.preview_image.src,
        width: this.currentVariant.featured_media.preview_image.width,
      };

      const widths = [165, 360, 533, 720, 940, 1066];

      const srcset = widths
        .filter((w) => cardProductMedia.width >= w)
        .map((w) => `${cardProductMedia.url}?width=${w} ${w}w`)
        .join(", ");

      const fullSrc = `${cardProductMedia.url} ${cardProductMedia.width}w`;
      const imgSrcSet = `${srcset}, ${fullSrc}`;

      const img = card.querySelector(".card-primary-image");
      const secondaryImg = card.querySelector(".card-secondary-image");
      if (img && cardProductMedia) {
        img.src = `${cardProductMedia.url}?width=720`;
        img.srcset = imgSrcSet;
        img.sizes = "(max-width: 720px) 100vw, 720px";
      }

      if (secondaryImg) {
        secondaryImg.style.opacity = 0;
        img.style.opacity = 1;
      }
    }

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    if (this.closest("product-card")) {
      const productCard = this.closest("product-card");
      const variantIdInput = productCard.querySelector(
        '.quick-add input[name="id"]'
      );

      if (variantIdInput) {
        variantIdInput.value = this.currentVariant.id;
      }
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");

      if (listOfAvailableOptions.includes(value)) {
        if (input.tagName === "OPTION") {
          input.innerText = value;
          input.disabled = false;
        } else if (input.type === "radio") {
          input.classList.remove("disabled");
          input.disabled = false;
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
          input.disabled = true;
        } else if (input.type === "radio") {
          input.classList.add("disabled");
          input.disabled = true;
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const destinationSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationSticky)
          destinationSticky.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (priceSticky) priceSticky.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        const destinationAddButton = document.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        if (addButtonUpdated && destinationAddButton) {
          destinationAddButton.innerHTML = addButtonUpdated.innerHTML;
        }

        var optionNames = this.querySelectorAll("[data-optionname]");

        var optionNamesNew = html.querySelectorAll("[data-optionname]");

        optionNames.forEach((optionName, index) => {
          optionName.replaceWith(optionNamesNew[index]);
        });

        var description = document.querySelector("[data-product-description]");

        var descriptionNew = html.querySelector("[data-product-description]");

        if (description && descriptionNew) {
          description.replaceWith(descriptionNew);
        }


        var ingredients = document.querySelector("[data-product-ingredients]");

        var ingredientsNew = html.querySelector("[data-product-ingredients]");

        if (ingredients && ingredientsNew) {
          ingredients.replaceWith(ingredientsNew);
        }

        var additionalInformation = document.querySelector(
          "[data-product-additional-information]"
        );

        var additionalInformationNew = html.querySelector(
          "[data-product-additional-information]"
        );

        if (additionalInformation && additionalInformationNew) {
          additionalInformation.replaceWith(additionalInformationNew);
        }

        var gallery = document.querySelector("[data-product-image-gallery]");

        var galleryNew = html.querySelector("[data-product-image-gallery]");

        if (gallery && galleryNew) {
          gallery.replaceWith(galleryNew);
          new Splide(".product-gallery-slider", productGalleryOptions).mount();
          requestAnimationFrame(() => {
            // Update text and reveal content after mount
            initContentProducerReveal();
            draggableCursor();
          });
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonTextSticky.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-${this.dataset.section}-support`
    );

    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky)
      addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");

    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original) {
    var originalSelectedItem = "";
    var originalSelectedItemValue = "";

    if (!original.classList.contains("option-select")) {
      var itemSelect = original.querySelector("select");
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    } else {
      originalSelectedItem = original.querySelector(
        'input[type="radio"]:checked'
      );
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if (!paired.classList.contains("option-select")) {
      var event = new Event("change");
      paired.querySelector("select").value = originalSelectedItemValue;
      paired
        .querySelector(`option[data-value="${originalSelectedItemValue}"`)
        .click();
      paired.dispatchEvent(event);
    } else {
      paired.querySelector(`input[type="radio"]:checked`).checked = false;
      var newTarget = paired
        .querySelector(`label[data-value="${originalSelectedItemValue}"`)
        .getAttribute("for");
      paired.querySelector(`input[type="radio"]#${newTarget}`).checked = true;
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class SiteToggle extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll(".js-site-toggle-control").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        this.classList.toggle("toggled");
      });
    });
  }
}

customElements.define("site-toggle", SiteToggle);

// Splide Sliders
const productGalleryOptions = {
  arrows: false,
  type: "loop",
  perPage: 1,
  drag: "free",
  snap: true,
  classes: {
    pagination: "splide__pagination product-gallery-pagination",
    page: "splide__pagination__page product-gallery-page",
  },
};

// Product Gallery
document.addEventListener("DOMContentLoaded", function () {
  const sliderElement = document.querySelector(".product-gallery-slider");
  if (sliderElement) {
    const splide = new Splide(".product-gallery-slider", productGalleryOptions);

    splide.on("mounted", () => {
      sliderElement.style.minHeight = `${sliderElement.offsetHeight}px`;
    });

    splide.mount();

    sliderElement.addEventListener("disableDrag", () => {
      splide.Components.Drag.disable(true);
    });

    sliderElement.addEventListener("enableDrag", () => {
      splide.Components.Drag.disable(false);
    });
  }
});

//UGC Toggle
const ugcToggle = document.getElementById("ugc-toggle");
if (ugcToggle) {
  let productGallery = document.getElementById("product-gallery");
  let productGalleryContent = productGallery.innerHTML;
  const ugcToggleText = document.getElementById("ugc-toggle-text");

  ugcToggle.addEventListener("change", function () {
    if (this.checked) {
      fetch(`?section_id=ugc-gallery`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          let nestedElement = html.getElementById(
            "shopify-section-ugc-gallery"
          );
          productGallery = document.getElementById("product-gallery");
          productGalleryContent = productGallery.innerHTML;
          productGallery.innerHTML = nestedElement.innerHTML;
        })
        .then(() => {
          // Wait for the DOM to fully update before initializing Splide
          requestAnimationFrame(() => {
            // Update text and reveal content after mount
            ugcToggleText.innerText = window.productStrings.return_ugc;

            initContentProducerReveal();
            draggableCursor();
          });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      productGallery.innerHTML = productGalleryContent;
      new Splide(".product-gallery-slider", { destroy: true }).mount();
      new Splide(".product-gallery-slider", productGalleryOptions).mount();
      ugcToggleText.innerText = window.productStrings.scroll_ugc;
      this.classList.add("interacted");
      // Ensure reveal function is called even when UGC gallery is not visible
      requestAnimationFrame(() => {
        initContentProducerReveal();
        draggableCursor();
      });
    }
  });
}

// Draggable Cursor
function draggableCursor() {
  let cursor = document.getElementById("customCursor");
  let draggableSliders = document.getElementsByClassName("is-draggable");

  Array.from(draggableSliders).forEach((slider) => {
    let isDragging = false;
    let startX, startY;

    slider.addEventListener("mousedown", (event) => {
      isDragging = false; // Reset flag
      startX = event.clientX;
      startY = event.clientY;
    });

    slider.addEventListener("mousemove", (event) => {
      if (
        Math.abs(event.clientX - startX) > 5 ||
        Math.abs(event.clientY - startY) > 5
      ) {
        isDragging = true; // Mouse moved enough to be considered a drag
      }
      let x = event.clientX;
      let y = event.clientY;
      cursor.style.left = `${x}px`;
      cursor.style.top = `${y}px`;
    });

    slider.addEventListener("mouseleave", () => {
      cursor.style.display = "none";
    });
    slider.addEventListener("mouseenter", () => {
      cursor.style.display = "flex";
    });

    const volumeElements = document.querySelectorAll(".volume");

    volumeElements.forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursor.style.display = "none";
      });

      el.addEventListener("mouseleave", () => {
        cursor.style.display = "flex";
      });
    });

    const cards = document.querySelectorAll("product-card");
    cards.forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursor.style.display = "none";
      });

      el.addEventListener("mouseleave", () => {
        cursor.style.display = "flex";
      });
    });
  });
}

// UGC Producer Animation
function initContentProducerReveal(
  containerSelector = ".product-gallery-content-producers"
) {
  const containers = document.querySelectorAll(containerSelector);

  containers.forEach((container) => {
    const boxes = container.querySelectorAll(".content-producer");
    const gap = parseFloat(getComputedStyle(container).gap || 0);
    let largeBoxHeight;

    // Get height of the large element above, if any
    const ugcMedia = container.closest(".ugc-media");
    if (ugcMedia) {
      largeBoxHeight =
        ugcMedia.querySelector(".content-producer--large")?.offsetHeight || 0;
    } else {
      largeBoxHeight = 0;
    }

    // Total height of all boxes including gaps
    let totalHeight = 0;
    boxes.forEach((box) => {
      totalHeight += box.offsetHeight;
      box.classList.add("is-hidden");
    });
    totalHeight += gap * (boxes.length - 1);

    container.style.setProperty("--totalHeight", totalHeight + "px");

    const firstBoxHeight = boxes[0].offsetHeight;

    function startRevealLoop() {
      let index = 1;
      // Reset visibility
      boxes.forEach((box) => box.classList.add("is-hidden"));
      boxes[0].classList.remove("is-hidden"); // Reveal first immediately

      // Push the container lower (more negative) if large box exists
      let currentOffset = -(totalHeight - firstBoxHeight) + largeBoxHeight + 20;
      container.style.bottom = currentOffset + "px";

      function revealNextBox() {
        if (index >= boxes.length) {
          setTimeout(startRevealLoop, 1200);
          return;
        }

        const stepHeight = boxes[index].offsetHeight + gap;
        currentOffset += stepHeight;
        container.style.bottom = currentOffset + "px";
        boxes[index].classList.remove("is-hidden");
        index++;
        setTimeout(revealNextBox, 800);
      }

      setTimeout(revealNextBox, 800);
    }

    startRevealLoop();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initContentProducerReveal();
  draggableCursor();
});

// Image Compare Styling
const observer = new MutationObserver(() => {
  const el = document.querySelector("image-compare"); // Look for the custom element
  if (el && el.shadowRoot) {
    const style = document.createElement("style"); // Create a new style element

    // Check if a style element already exists inside the shadow root
    const existingStyle = el.shadowRoot.querySelector("style");
    if (existingStyle) {
      // If there's an existing style, append the new CSS rule
      existingStyle.textContent += `
        slot[name="image-1"], slot[name="image-2"] {
          height: 100%; /* Ensure the slot takes full height */
        }

        ::slotted([slot="image-1"]) {
          height: 100%;
        }
        ::slotted([slot="image-2"]) {
          height: 100%;
        }
      `;
    } else {
      // If there's no existing style, append a new one
      style.textContent = `
        slot[name="image-1"], slot[name="image-2"] {
          height: 100%; /* Ensure the slot takes full height */
        }
        ::slotted([slot="image-1"]) {
          height: 100%;
          display: block; /* Ensure the image stretches correctly */
        }
        ::slotted([slot="image-2"]) {
          height: 100%;
          display: block; /* Ensure the image stretches correctly */
        }
      `;
      el.shadowRoot.appendChild(style);
    }

    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

function updateDyanmicElementPosition() {
  const announcementBar = document.querySelector(".announcement-bar-section");
  const siteHeader = document.querySelector(".site-header");
  const drawers = document.querySelectorAll(
    ".site-menu__level-1, .site-menu__level-2, .site-menu__level-3, .cart-drawer"
  );
  const notificationFeed = document.querySelector(".notification-feed");

  if (!siteHeader || (drawers.length === 0 && !notificationFeed)) return;

  const productBadge = document.querySelector(".product-gallery-badge");
  const discoveryFeed = document.querySelector(".discovery-feed__search-input");

  if (notificationFeed) {
    // Updates PDP Badge Position
    if (productBadge) {
      const notificationFeedHeight = notificationFeed.offsetHeight;
      productBadge.style.setProperty(
        "--badgePosition",
        notificationFeedHeight + "px"
      );
    }
    // Update Discovery Feed Search
    if (discoveryFeed) {
      discoveryFeed.style.setProperty("--leftMargin", "7rem");
    }
  }

  let headerHeight = siteHeader.offsetHeight;

  let announcementBarHeight = 0;

  if (announcementBar) {
    const rect = announcementBar.getBoundingClientRect();

    announcementBarHeight = Math.max(
      0,
      Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
    );
  }

  let scrollPosition = window.scrollY;

  headerHeight = headerHeight + announcementBarHeight;

  if (scrollPosition > announcementBarHeight) {
    drawers.forEach((drawer) => {
      drawer.style.top = `${headerHeight}px`;
    });
    if (notificationFeed) {
      notificationFeed.style.top = `calc(${headerHeight}px + 2rem)`;
    }
  } else {
    drawers.forEach((drawer) => {
      drawer.style.top = "";
    });
    if (notificationFeed) {
      notificationFeed.style.top = "";
    }
  }
}

document.addEventListener("scroll", updateDyanmicElementPosition);
document.addEventListener("DOMContentLoaded", updateDyanmicElementPosition);

const scrollLink = document.querySelector(".js-scroll-cta");
if (scrollLink && scrollLink.getAttribute("href").indexOf("#") === 0) {
  scrollLink.addEventListener("click", () => {
    document.querySelector("body").classList.remove("menu-active");
  });
}
